<script setup>
import { CenterModal, DmButton, DmTag, EmptyState, ErrorHighlighter, ModalButtons, TextArea } from 'dmui_components'
import { computed, ref } from 'vue'
import noSectionDetails from '@/assets/img/file-search-alt.svg'
const props = defineProps({
	reportId: {
		type: Number,
		default: undefined
	},
	sectionTypes: {
		type: Array,
		default: () => []
	}
})

const EXPECTED_SECTIONS = { Item1: [], Item1A: [], Item1C: [], Item7: [] }

function getSectionData(data, expectedSections) {
	return data.reduce((acc, { item, text }) => ({ ...acc, [item]: [...(acc[item] || []), text] }), { ...expectedSections })
}

const sectionData = computed(() => getSectionData(props.sectionTypes, EXPECTED_SECTIONS))

const contentModalIndex = ref(null)
</script>
<template>
	<div v-if="reportId && sectionTypes.length" class="section-data-table">
		<div class="page-details-header secondary-text bold">
			<div>Section</div>
			<div>Content</div>
		</div>
		<template v-for="([item, texts], index) in Object.entries(sectionData)" :key="index">
			<ErrorHighlighter :id="`error-highlighter-${index}`">
				<span class="secondary-text"> {{ item }} </span>
				<DmTag>{{ texts.length ? 'Extracted' : 'Not Extracted' }}</DmTag>
				<DmButton v-if="texts.length" :id="`${item}-content`" class="slim transparent" @click="contentModalIndex = index"> view content </DmButton>
			</ErrorHighlighter>

			<CenterModal v-if="contentModalIndex === index" style="width: 666px">
				<div class="text-content-modal">
					<h3 class="primary-text bold">{{ item }}</h3>
					<TextArea :data="texts.join('\n')" readonly="true" rows="20"> </TextArea>
					<ModalButtons>
						<DmButton id="cancel" class="secondary" @click="contentModalIndex = null">Cancel</DmButton>
					</ModalButtons>
				</div>
			</CenterModal>
		</template>
	</div>
	<EmptyState v-else :image="noSectionDetails">
		<template #title> 10k Sections </template>
		<template #description>
			{{ reportId ? 'There are no section details to be displayed' : 'Sections for 10k reports will be generated automatically after processing the report' }}
		</template>
	</EmptyState>
</template>

<style scoped lang="less">
.page-details-header,
:deep(.container) {
	display: grid;
	grid-template-columns: 150px 1fr 1fr;
	align-items: center;
	column-gap: @midi;
	padding-bottom: @micro;
}
.page-details-header {
	border-bottom: 1px solid @gray-50;
	margin-bottom: 19px;
	margin-top: @midi;
}

:deep(.container) {
	border-bottom: 1px solid @gray-30;
}

:deep(.image) {
	height: @huge;
}

.text-content-modal {
	padding: @midi;
	display: flex;
	flex-direction: column;
}
</style>
